import './SwitchBlindsChipsButton.styles.scss';

import { observer } from 'mobx-react';
import { SelectButton } from 'primereact/selectbutton';
import React, { FC } from 'react';

import commonStore from '../../../../store/CommonStore';

const SwitchBlindsChipsButton: FC = () => (
  <SelectButton
    className="SwitchBlindsChipsButton-Component"
    value={commonStore.getIsChipsConvertedToBlinds() ? 'BLINDS' : 'CHIPS'}
    onChange={commonStore.toggleIsChipsConvertedToBlinds}
    options={['BLINDS', 'CHIPS']}
    data-ignore-outside-click
  />
);

export default observer(SwitchBlindsChipsButton);
